import { Toast } from 'vant'
import { apiPrefixes } from '@/api/apiPrefixes'
import {
  httpWithCookieAndLoading as lhttp,
  httpWithCookie,
  ResultType,
  toLogin
} from '@/utils'
import qs from 'query-string'
import {
  BaseInfo,
  ResumeInfo,
  Remark,
  Attachment,
  InterviewRecord,
  ResumeSimpleInfo,
  SummaryDetail,
  Dept,
  FilterRecord
} from '@/interfaces/interviewer/detail'
import { TNcConf } from '@/interfaces/recruitModel'
import { BaseConfig } from '@/interfaces/baseconfig'

const api = {
  // 数据主档 学历信息
  getNcConf: `${apiPrefixes.ehr}/sysConf/getNcConf.do`,

  // 获取品类信息
  getBaseConfList: `${apiPrefixes.ehr}/baseConfig/getList.do`,
  /**
   * 招聘客户端----面试官----我的候选人
   */
  // 候选人详情-简历详情标准简历
  getResumeByResumeId: `${apiPrefixes.ehr}/recruitEmploy/getResumeByResumeId.do`,
  // 候候选人详情-备注列表
  queryRemark: `${apiPrefixes.ehr}/recruitEmploy/queryRemark.do`,
  // 候选人详情-附加材料
  queryAttachments: `${apiPrefixes.ehr}/sysatt/queryAttachments.do`,
  // 候选人详情-详情页头部信息
  getResumeByApplyId: `${apiPrefixes.ehr}/recruitEmploy/getResumeByApplyId.do`,
  // 候选人推荐职位接口
  recommend: `${apiPrefixes.ehr}/recruitEmploy/updateStage.do`,
  // 需求部门列表 和 需求部门列表 --- 获取对应部门下所有职位
  demandList: `${apiPrefixes.ehr}/postManagement/queryPostListGroupByDept.do`,
  // 候选人备注新增/编辑
  saveRemark: `${apiPrefixes.ehr}/recruitEmploy/saveRemark.do`,
  // 候选人备注删除
  deleteRemark: `${apiPrefixes.ehr}/recruitEmploy/deleteRemark.do`,
  // 我要面试/不合适
  notAgreeMeet: `${apiPrefixes.ehr}/recruitManage/notAgreeMeet.do`,
  // 我要面试/不合适
  agreeMeet: `${apiPrefixes.ehr}/recruitManage/agreeMeet.do`,

  /**
   * 招聘客户端----面试官----我的面试
   */
  // 候选人面试安排列表
  getInterArrangementByInterviewId: `${apiPrefixes.ehr}/interviewManage/getInterViewById.do`,
  // 调整面试官
  adjustInterview: `${apiPrefixes.ehr}/interviewManage/adjustInterview.do`,
  // 面试评价
  saveSummary: `${apiPrefixes.ehr}/interviewManage/saveSummary.do`,
  // 面试评价详情
  getSummary: `${apiPrefixes.ehr}/interviewManage/getSummary.do`,

  /**
   * 招聘客户端----面试官---公共人才库
   */
  // 达人 筛选记录
  getFilterByResumeId: `${apiPrefixes.ehr}/recruitMicro/getFilterByResumeId.do`,
  // 候选人应聘记录
  getApplyListByResumeId: `${apiPrefixes.ehr}/recruitEmploy/getApplyListByResumeId.do`
}

async function requstData(requestParams: any) {
  try {
    const res: any = await httpWithCookie(requestParams)
    if (+res.code === 1024) {
      toLogin()
    } else if (+res.code === 1) {
      return res
    } else {
      Toast(res.msg)
      return Promise.reject(res.msg)
    }
  } catch (e) {
    return Promise.reject()
  }
}

export default {
  // 获取所有城市列表
  async fetchZones(cityPk: string) {
    return httpWithCookie.get(`${api.getNcConf}?code=42&parentPk=${cityPk}`)
  },

  async getNcCon(params: { code: string; keyword?: string; parentPk: string }) {
    try {
      const result: ResultType<TNcConf[]> = await lhttp.get(
        `${api.getNcConf}?${qs.stringify(params)}`
      )
      const { data, code, msg } = result
      if (+code === 1) {
        return data || []
      } else if (+code == 1024) {
        toLogin()
      } else {
        throw msg
      }
    } catch (e) {
      console.error(e)
      if (typeof e == 'string') {
        throw e
      }
      throw '网络异常'
    }
  },
  async getBaseConfList(params: {
    code: string
    type?: string
    keyword?: string
  }) {
    try {
      const result: ResultType<BaseConfig[]> = await lhttp.get(
        `${api.getBaseConfList}?${qs.stringify(params)}`
      )
      const { data, code, msg } = result
      if (+code === 1) {
        return data || []
      } else if (+code == 1024) {
        toLogin()
      } else {
        throw msg
      }
    } catch (e) {
      console.error(e)
      if (typeof e == 'string') {
        throw e
      }
      throw '网络异常'
    }
  },
  /**
   * 招聘客户端----面试官----我的候选人
   */
  // 候选人详情-简历详情标准简历
  async getResumeByResumeId(params: { resumeId?: string; type: number }) {
    try {
      const result: ResultType<ResumeInfo | ResumeSimpleInfo> = await lhttp.get(
        `${api.getResumeByResumeId}?${qs.stringify(params)}`
      )
      const { data, code, msg } = result
      if (+code === 1) {
        return data || {}
      } else if (+code == 1024) {
        toLogin()
      } else {
        throw msg
      }
    } catch (e) {
      console.error(e)
      if (typeof e == 'string') {
        throw e
      }
      throw '网络异常'
    }
  },
  // 候候选人详情-备注列表
  async queryRemark(resumeId: string) {
    try {
      const result: ResultType<Remark[]> = await lhttp.get(
        `${api.queryRemark}?${qs.stringify({ resumeId })}`
      )
      const { data, code, msg } = result
      if (+code === 1) {
        return data || []
      } else if (+code == 1024) {
        toLogin()
      } else {
        throw msg
      }
    } catch (e) {
      console.error(e)
      if (typeof e == 'string') {
        throw e
      }
      throw '网络异常'
    }
  },
  // 候选人详情-附加材料
  async queryAttachments(params: {
    objectId: string
    objectType?: number
    fileType?: number
  }) {
    try {
      params.objectType = 7
      params.fileType = 25
      const result: ResultType<Attachment[]> = await lhttp.get(
        `${api.queryAttachments}?${qs.stringify(params)}`
      )
      const { data, code, msg } = result
      if (+code === 1) {
        return data || []
      } else if (+code == 1024) {
        toLogin()
      } else {
        throw msg
      }
    } catch (e) {
      console.error(e)
      if (typeof e == 'string') {
        throw e
      }
      throw '网络异常'
    }
  },
  // 候选人详情-详情页头部信息
  async getResumeByApplyId(params: { resumeId?: string; applyId?: string }) {
    try {
      const result: ResultType<BaseInfo> = await lhttp.get(
        `${api.getResumeByApplyId}?${qs.stringify(params)}`
      )
      const { data, code, msg } = result
      if (+code === 1) {
        return data || {}
      } else if (+code == 1024) {
        toLogin()
      } else {
        throw msg
      }
    } catch (e) {
      console.error(e)
      if (typeof e == 'string') {
        throw e
      }
      throw '网络异常'
    }
  },
  // 候选人推荐职位接口
  async recommend(params: {
    applyId?: string
    resumeId?: string
    stage?: string
    postId?: string
    type?: string
  }) {
    try {
      const result: any = await lhttp.post(`${api.recommend}`, params, {
        headers: {
          'Content-Type': 'application/json'
        }
      })
      const { data, code, msg } = result
      if (+code === 1) {
        return data || {}
      } else if (+code == 1024) {
        toLogin()
      } else {
        throw msg
      }
    } catch (e) {
      console.error(e)
      if (typeof e == 'string') {
        throw e
      }
      throw '网络异常'
    }
  },
  // 需求部门列表
  async demandList(deptKeyword?: string) {
    try {
      const result: ResultType<Dept[]> = await lhttp.get(
        `${api.demandList}?type=dept&deptKeyword=${deptKeyword}`
      )
      const { data, code, msg } = result
      if (+code === 1) {
        return data || {}
      } else if (+code == 1024) {
        toLogin()
      } else {
        throw msg
      }
    } catch (e) {
      console.error(e)
      if (typeof e == 'string') {
        throw e
      }
      throw '网络异常'
    }
  },
  // 职位列表
  async positionList(params: { deptPk?: string; postKeyword?: string }) {
    try {
      const result: ResultType<Dept[]> = await lhttp.get(
        `${api.demandList}?type=post&${qs.stringify(params)}`
      )
      const { data, code, msg } = result
      if (+code === 1) {
        return data || {}
      } else if (+code == 1024) {
        toLogin()
      } else {
        throw msg
      }
    } catch (e) {
      console.error(e)
      if (typeof e == 'string') {
        throw e
      }
      throw '网络异常'
    }
  },
  // 候选人详情-备注新增/更新
  async saveRemark(params: { id?: string; resumeId: string; remark: string }) {
    try {
      const result: ResultType<any> = await lhttp.post(
        `${api.saveRemark}`,
        params,
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      )
      const { data, code, msg } = result
      if (+code === 1) {
        return data || {}
      } else if (+code == 1024) {
        toLogin()
      } else {
        throw msg
      }
    } catch (e) {
      console.error(e)
      if (typeof e == 'string') {
        throw e
      }
      throw '网络异常'
    }
  },
  // 候选人备注删除
  async deleteRemark(id: string) {
    try {
      const result: any = await lhttp.get(`${api.deleteRemark}?id=${id}`)
      const { data, code, msg } = result
      if (+code === 1) {
        return data || {}
      } else if (+code == 1024) {
        toLogin()
      } else {
        throw msg
      }
    } catch (e) {
      console.error(e)
      if (typeof e == 'string') {
        throw e
      }
      throw '网络异常'
    }
  },
  // 不合适
  async notAgreeMeet(params: {
    applyId?: string
    remark?: string
    type: number
    resumeId?: string
  }) {
    try {
      const result: any = await lhttp.post(`${api.notAgreeMeet}`, params, {
        headers: {
          'Content-Type': 'application/json'
        }
      })
      const { data, code, msg } = result
      if (+code === 1) {
        return data || {}
      } else if (+code == 1024) {
        toLogin()
      } else {
        throw msg
      }
    } catch (e) {
      console.error(e)
      if (typeof e == 'string') {
        throw e
      }
      throw '网络异常'
    }
  },
  // 我要面试
  async agreeMeet(params: {
    applyId?: string
    remark?: string
    type: number
    resumeId?: string
  }) {
    try {
      const result: any = await lhttp.post(`${api.agreeMeet}`, params, {
        headers: {
          'Content-Type': 'application/json'
        }
      })
      const { data, code, msg } = result
      if (+code === 1) {
        return data || {}
      } else if (+code == 1024) {
        toLogin()
      } else {
        throw msg
      }
    } catch (e) {
      console.error(e)
      if (typeof e == 'string') {
        throw e
      }
      throw '网络异常'
    }
  },

  /**
   * 招聘客户端----面试官----我的面试
   */
  // 候选人面试安排列表
  async getInterArrangementByInterviewId(interviewId: string) {
    try {
      const result: ResultType<InterviewRecord[]> = await lhttp.get(
        `${api.getInterArrangementByInterviewId}?interviewId=${interviewId}`
      )
      const { data, code, msg } = result
      if (+code === 1) {
        return data || []
      } else if (+code == 1024) {
        toLogin()
      } else {
        throw msg
      }
    } catch (e) {
      console.error(e)
      if (typeof e == 'string') {
        throw e
      }
      throw '网络异常'
    }
  },
  // 调整面试官
  async adjustInterview(params: { id: string; interviewerCode: string[] }) {
    try {
      const result: ResultType<any> = await lhttp.post(
        `${api.adjustInterview}`,
        params,
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      )
      const { data, code, msg } = result
      if (+code === 1) {
        return data || {}
      } else if (+code == 1024) {
        toLogin()
      } else {
        throw msg
      }
    } catch (e) {
      console.error(e)
      if (typeof e == 'string') {
        throw e
      }
      throw '网络异常'
    }
  },
  // 面试评价
  async saveSummary(params: {
    interviewId: number
    summaryId?: string
    summary?: string
    bandPk: string
    status: number
  }) {
    try {
      const result: any = await lhttp.post(`${api.saveSummary}`, params, {
        headers: {
          'Content-Type': 'application/json'
        }
      })
      const { data, code, msg } = result
      if (+code === 1) {
        return data || {}
      } else if (+code == 1024) {
        toLogin()
      } else {
        throw msg
      }
    } catch (e) {
      console.error(e)
      if (typeof e == 'string') {
        throw e
      }
      throw '网络异常'
    }
  },
  // 面试评价详情
  async getSummary(summaryId: string) {
    try {
      const result: ResultType<SummaryDetail> = await lhttp.get(
        `${api.getSummary}?summaryId=${summaryId}`
      )
      const { data, code, msg } = result
      if (+code === 1) {
        return data || {}
      } else if (+code == 1024) {
        toLogin()
      } else {
        throw msg
      }
    } catch (e) {
      console.error(e)
      if (typeof e == 'string') {
        throw e
      }
      throw '网络异常'
    }
  },

  /**
   * 招聘客户端----面试官---公共人才库
   */
  // 达人 筛选记录
  async getFilterByResumeId(resumeId: string) {
    try {
      const result: ResultType<FilterRecord[]> = await lhttp.get(
        `${api.getFilterByResumeId}?resumeId=${resumeId}&type=1`
      )
      const { data, code, msg } = result
      if (+code === 1) {
        return data || []
      } else if (+code == 1024) {
        toLogin()
      } else {
        throw msg
      }
    } catch (e) {
      console.error(e)
      if (typeof e == 'string') {
        throw e
      }
      throw '网络异常'
    }
  },
  //候选人应聘记录
  async getApplyListByResumeId(resumeId: string) {
    try {
      const result: ResultType<any[]> = await lhttp.get(
        `${api.getApplyListByResumeId}?resumeId=${resumeId}`
      )
      const { data, code, msg } = result
      if (+code === 1) {
        data.forEach(val => {
          val.filterUserName = val?.postEntity?.postName || ''
          val.statusDesc = val?.channelDes || ''
          val.filterTime = val?.applyTimeStr || ''
        })
        return data || []
      } else if (+code == 1024) {
        toLogin()
      } else {
        throw msg
      }
    } catch (e) {
      console.error(e)
      if (typeof e == 'string') {
        throw e
      }
      throw '网络异常'
    }
  },

  fetchPostByDept(params: any) {
    return requstData({
      url: `${apiPrefixes.ehr}/postManagement/queryPostByDept.do`,
      method: 'POST',
      data: params
    })
  },

  fetchVideoResume(params: any) {
    return requstData({
      url: `${apiPrefixes.ehr}/postManagement/getResumeByResumeId.do`,
      params
    })
  },
  // 敏感信息查看
  fetchSensitiveDetail(params?: any) {
    return requstData({
      url: `${apiPrefixes.ehr}/recruitSensitive/querySensitive.do`,
      params
    })
  },
  saveSensitiveApi(params: any) {
    return requstData({
      url: `${apiPrefixes.ehr}/recruitSensitive/save.do`,
      method: 'POST',
      data: params
    })
  },
  fetchHasSensitivePerm(params?: any) {
    return requstData({
      url: `${apiPrefixes.ehr}/recruitSensitive/hasPerm.do`,
      params
    })
  }
}
